import React, { Fragment } from "react"
import classnames from "classnames"

import InvoicesSummarySkeleton from "../InvoicesSummarySkeleton"

import styles from "./styles.css"

const MainPageSkeleton = () => {
  const titleClasses = classnames(styles.skeletonText, styles.skeleton)
  const cardClasses = classnames(
    styles.cardSkeleton,
    styles.whiteBackgroundSkeleton
  )
  const bannerClasses = classnames(
    styles.banner,
    styles.greenBackgroundSkeleton
  )
  const halfBannerClasses = classnames(
    styles.halfBanner,
    styles.greenBackgroundSkeleton
  )

  return (
    <Fragment>
      <div className={titleClasses}></div>
      <InvoicesSummarySkeleton />
      <div className={titleClasses}></div>
      <div className="u-flex">
        <div className={cardClasses}></div>
        <div className={cardClasses}></div>
        <div className={cardClasses}></div>
        <div className={cardClasses}></div>
      </div>
      <div className={bannerClasses}></div>
      <div className="u-flex u-flexJustifyBetween">
        <div className={halfBannerClasses}></div>
        <div className={halfBannerClasses}></div>
      </div>
    </Fragment>
  )
}

export default MainPageSkeleton



// WEBPACK FOOTER //
// ./src/components/Skeleton/MainPageSkeleton/index.js